<div class=" labelWidget">
    <label>{{widgetInfo?.title}}</label>
</div>